import React from 'react'
import {Icon} from '@chakra-ui/react'

const GoBackIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M31.0636 32.7067H21.0771C20.5574 32.7067 20.1323 32.2815 20.1323 31.7619C20.1323 31.2422 20.5574 30.8171 21.0771 30.8171H31.0636C31.3093 30.8171 37.1104 30.7037 37.1104 24.3924C37.1104 18.0811 31.3093 17.8922 31.0542 17.8922H4.18399L10.3819 24.2507C10.7504 24.6286 10.7409 25.2239 10.363 25.5829C9.99453 25.9513 9.38986 25.9419 9.03083 25.564L1.27399 17.6087C1.27399 17.6087 1.2362 17.5709 1.22675 17.552C1.10393 17.4103 1.03779 17.2403 1.00945 17.0607C1.00945 17.0041 1.00945 16.9474 1.00945 16.8907H1C1.00945 16.6734 1.10393 16.4655 1.2551 16.2955H1.26454L9.09697 8.28352C9.46544 7.91505 10.0607 7.9056 10.4291 8.26463C10.6181 8.45359 10.7126 8.69924 10.7126 8.94489C10.7126 9.19053 10.6181 9.41729 10.4386 9.60625L4.18399 16.0026H31.0636C31.1392 16.0026 39 16.097 39 24.3924C39 30.9683 33.8036 32.7067 31.0636 32.7067Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default GoBackIcon
